<app-time-slot-list *ngIf="!isEvent" (timeSlotSelected)="onTimeSlotSelected($event)"></app-time-slot-list>
<app-time-slot-event-list *ngIf="isEvent" (timeSlotSelected)="onTimeSlotSelected($event)"></app-time-slot-event-list>
